import { render, staticRenderFns } from "./InputFiles.vue?vue&type=template&id=6904f466&"
import script from "./InputFiles.vue?vue&type=script&lang=js&"
export * from "./InputFiles.vue?vue&type=script&lang=js&"
import style0 from "./InputFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports